module.exports = __webpack_public_path__ + "static/media/Janne.ba996c69.jpg";